import { type ServiceWorkerMessages } from "./ServiceWorkerMessages.type";

function onServiceWorkerRegistration(
  registration: ServiceWorkerRegistration,
): void {
  console.log("[service_worker] registered with scope:", registration.scope);

  registration.addEventListener("updatefound", function () {
    console.log("[service_worker] update found");

    const newWorker = registration.installing;

    newWorker?.addEventListener("statechange", function () {
      console.log("[service_worker] new worker state:", newWorker.state);

      if (
        newWorker.state === "installed" &&
        navigator.serviceWorker.controller
      ) {
        document.dispatchEvent(
          new CustomEvent("intentt:serviceWorkerInstalled"),
        );
      }
    });
  });
}

export async function registerServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) {
    console.warn(
      "[service_worker] service worker not supported; only available in secure contexts and on localhost",
    );

    return;
  }

  await navigator.serviceWorker
    .register("/service_worker.js", {
      scope: "/",
      type: "module",
      updateViaCache: "none",
    })
    .then(onServiceWorkerRegistration);

  await navigator.serviceWorker.ready;

  const message: Partial<ServiceWorkerMessages> = {
    setBuildVersion: [{ buildVersion: __BUILD_ID }],
  };

  navigator.serviceWorker.controller?.postMessage(message);
}

registerServiceWorker().catch(function (error: unknown) {
  console.error("[service_worker] registration failed:", error);
});
